import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { TextField, FormHelperText, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled wrapper to make react-phone-number-input look like MUI TextField
const StyledPhoneInputWrapper = styled(Box)(({ theme, error }) => ({
  '& .PhoneInput': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .PhoneInputCountry': {
    marginRight: theme.spacing(1),
    border: 'none',
    background: 'transparent',
  },
  '& .PhoneInputCountrySelect': {
    border: 'none',
    background: 'transparent',
    fontSize: '16px',
    cursor: 'pointer',
  },
  '& .PhoneInputInput': {
    flex: 1,
    outline: 'none',
    fontSize: '16px',
    padding: '16.5px 14px',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${error ? theme.palette.error.main : theme.palette.divider}`,
    '&:hover': {
      borderColor: error ? theme.palette.error.main : theme.palette.text.primary,
    },
    '&:focus': {
      borderColor: error ? theme.palette.error.main : theme.palette.primary.main,
      borderWidth: '2px',
      padding: '15.5px 13px', // Adjust padding when border increases
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
}));

/**
 * Phone Number Input Component for US phone numbers only
 *
 * Features:
 * - US phone number formatting only
 * - Fixed to US country code (+1)
 * - Real-time validation
 * - Material-UI styling
 * - E.164 format output
 */
const PhoneNumberInput = ({
  value,
  onChange,
  error,
  helperText,
  label,
  required = false,
  placeholder = "Enter a US phone number",
  ...props
}) => {
  const handleChange = (phoneValue) => {
    // phoneValue is already in E.164 format or undefined
    onChange(phoneValue || '');
  };

  return (
    <Box>
      {label && (
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontSize: '12px',
          fontWeight: 400,
          color: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.6)'
        }}>
          {label}{required && ' *'}
        </label>
      )}

      <StyledPhoneInputWrapper error={error}>
        <PhoneInput
          value={value}
          onChange={handleChange}
          defaultCountry="US"
          countries={["US"]}
          international={false}
          countryCallingCodeEditable={false}
          placeholder={placeholder}
          {...props}
        />
      </StyledPhoneInputWrapper>

      {(error || helperText) && (
        <FormHelperText error={error}>
          {error ? error : helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default PhoneNumberInput;
